import * as actions from 'app/actions/subscriptions';

const BASE_URL = '/ecom/api/v1/';

export const fetchSubscriptionsStatus = () => ({
  promise: async http => (http.get(`${BASE_URL}subscriptions/current`)),
  events: [actions.LOADING_SUBSCRIPTIONS, actions.SET_SUBSCRIPTIONS_STATUS, 'PROMISE_ERROR'],
});

// TODO: how to make this ignore errors?
export const fetchSubscriptionUsers = () => ({
  promise: async http => (http.get(`${BASE_URL}subscriptions/current/added_users`)),
  events: [actions.RELOADING_SUBSCRIPTIONS, actions.SET_SUBSCRIPTIONS_USERS, 'PROMISE_ERROR'],
});

const addedUserUrl = id => (
  `${BASE_URL}subscriptions/${id}/added_users`
);

export const addUserAsMember = (id, email, afterComplete) => ({
  promise: async (http) => {
    await (http.post(addedUserUrl(id), { secondary_user_email: email }));
    afterComplete();
  },
  events: [actions.RELOADING_SUBSCRIPTIONS, actions.SUBSCRIPTIONS_USER_ADDED, 'PROMISE_ERROR'],
});

export const removeUserAsMember = (id, addedUserId, afterComplete) => ({
  promise: async (http) => {
    await http.delete(`${addedUserUrl(id)}/${addedUserId}`);
    afterComplete();
  },
  events: [actions.RELOADING_SUBSCRIPTIONS, actions.SUBSCRIPTIONS_USER_REMOVED, 'PROMISE_ERROR'],
});

export const manageSubscription = (url, afterComplete) => ({
  promise: async (http) => {
    // TODO: we parse out the url and assume the pathname is available on the
    // version of gf-ecom this is configured to talk to, instead of just using
    // the full provided link which would be assuming less about what system
    // hosts this operation. But for now this works.
    const parsedUrl = new URL(url);
    const result = await (http.post(parsedUrl.pathname, ''));
    if (result.url) {
      afterComplete(result.url);
    }
    // This intentionally does not retry but uses PROMISE_ERROR to cause the
    // user to refresh and try again.
  },
  events: [actions.MANAGE_PENDING, actions.MANAGE_DONE, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/api/subscriptions.js